export const isAuthenticated = () => {
  return !!localStorage.getItem('accessToken');
};

export const logoutUser = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('adminUser');
};
